var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#264D6F"
    },
    d: "M512,256c0,25.976-3.866,51.054-11.065,74.679c0,0.01,0,0.01-0.01,0.021 c-8.307,27.261-21.023,52.59-37.345,75.149v0.01c-23.27,32.172-53.844,58.723-89.276,77.218 c-10.439,5.454-21.295,10.209-32.507,14.19c-9.091,3.239-18.422,5.966-27.961,8.171h-0.01C295.236,509.733,275.895,512,256,512 c-41.535,0-80.75-9.885-115.43-27.439c-32.423-16.405-60.886-39.508-83.55-67.49c-20.605-25.412-36.425-54.847-46.122-86.946 C3.814,306.667,0,281.778,0,256C0,114.615,114.615,0,256,0S512,114.615,512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3876AC"
    },
    d: "M372.12,111.783V238.07c0,29.727-24.095,53.823-53.823,53.823H188.928 c-37.397,0-67.709,30.323-67.709,67.72v62.025H78.921c-7.659,0-15.015-1.515-21.901-4.566 c-20.605-25.412-36.425-54.847-46.122-86.946c-0.763-7.92-1.16-16.374-1.16-25.36c0-78.461,30.981-116.872,69.183-116.872h177.789 v-18.223H138.386v-57.887c0-29.393,52.328-53.227,116.872-53.227S372.12,82.39,372.12,111.783z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F2F2F2"
    },
    cx: 189.325,
    cy: 116.621,
    r: 21.506
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CD00"
    },
    d: "M502.951,298.026c0,11.786-0.7,22.674-2.017,32.653c0,0.01,0,0.01-0.01,0.021 c-8.307,27.261-21.023,52.59-37.345,75.149v0.01c-9.028,6.029-19.132,9.028-29.8,9.028H255.99v18.233h118.314v49.957 c-10.439,5.454-21.295,10.209-32.507,14.19c-9.091,3.239-18.422,5.966-27.961,8.171h-0.01C295.236,509.733,275.895,512,256,512 c-41.535,0-80.75-9.885-115.43-27.439V364.722c0-29.727,24.106-53.833,53.833-53.833h129.369c37.397,0,67.709-30.313,67.709-67.709 v-62.025h42.297C471.98,181.154,502.951,218.77,502.951,298.026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M344.879,486.17c0,4.065-1.128,7.868-3.082,11.097c-9.091,3.239-18.422,5.966-27.961,8.171h-0.01 c-7.084-3.511-11.954-10.825-11.954-19.268c0-11.88,9.624-21.504,21.504-21.504C335.255,464.666,344.879,474.29,344.879,486.17z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.17c9a06b32be2e74803bd668180ae08f.svg";
export { ForwardRef as ReactComponent };